'use client';
import { useRouter, redirect } from 'next/navigation';
import { useEffect, useCallback } from 'react';
import { isBrowser } from '@spot-fe/utils';
import { isSupport, getDefaultLang, loadLocale } from './utils';
import { useI18n } from '@spot-fe/base-ui';

export const useRedirect = (isRedirect?: boolean) => {
  const router = useRouter();

  const un = useEffect(() => {
    const defaultLang = getDefaultLang();

    if (isBrowser) {
      const path = `${location.pathname}${location.search}`;
      const lang = path.split(/\/+/)[1];

      if (!isSupport(lang)) {
        const baseUrl = `/${defaultLang}${path}`;
        const baseUrlReplaceLang = `/${defaultLang}${path.replace(lang, '')}`;
        if (path.startsWith('/trade/spot')) {
          isRedirect ? redirect(baseUrl) : router.push(baseUrl);
        } else {
          isRedirect
            ? redirect(baseUrlReplaceLang)
            : router.push(baseUrlReplaceLang);
        }
      }
    } else {
      const defaultUrl = `/${defaultLang}/trade/spot/spotx`;
      isRedirect ? redirect(defaultUrl) : router.push(defaultUrl);
    }
  }, [router, isRedirect]);

  return un;
};

// interface LocaleOptions {
//   locale: string;
//   messages?: Record<string, string>;
// }

export const useLocale = () => {
  const i18nCtx = useI18n();

  const fn = useCallback(async () => {
    const localeData = await loadLocale(i18nCtx?.locale);
    i18nCtx?.replace(localeData);
  }, [i18nCtx?.locale]);

  useEffect(() => {
    fn();
  }, [fn]);

  return null;
};
